export const SET_ORDER_MANAGEMENT_TASK_LIST_DATA = "SET_ORDER_MANAGEMENT_TASK_LIST_DATA";
export const SET_ORDER_MANAGEMENT_TASK_LIST_PAGINATION_DATA = "SET_ORDER_MANAGEMENT_TASK_LIST_PAGINATION_DATA";
export const SET_ORDER_MANAGEMENT_TASK_DETAIL_DATA = "SET_ORDER_MANAGEMENT_TASK_DETAIL_DATA";
export const SET_ORDER_MANAGEMENT_TASK_ISSUE_DATA = "SET_ORDER_MANAGEMENT_TASK_ISSUE_DATA";
export const RESET_ORDER_MANAGEMENT_REDUCER = "RESET_ORDER_MANAGEMENT_REDUCER";
export const SET_STORE_IDS_FILTER = "SET_STORE_IDS_FILTER";
export const SET_ORDER_MANAGEMENT_TASK_NEW_DATA = "SET_ORDER_MANAGEMENT_TASK_NEW_DATA";
export const SET_ORDER_MANAGEMENT_TASK_NEW_PAGINATION_DATA = "SET_ORDER_MANAGEMENT_TASK_NEW_PAGINATION_DATA";
export const SET_ORDER_FILTER = "SET_ORDER_FILTER";
export const SET_ORDER_FILTER_STORE = "SET_ORDER_FILTER_STORE";
export const SET_ORDER_FILTER_CLICK_SEARCH = "SET_ORDER_FILTER_CLICK_SEARCH";
export const SET_STATUS_MARK_DATA = "SET_STATUS_MARK_DATA";
export const SET_ORDER_CANCEL_CONFIRMATION = "SET_ORDER_CANCEL_CONFIRMATION";